import React, { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import './Detail.scss';
import common from '../../common';
import axios from 'axios';

import { useSelector } from 'react-redux';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const { useModal } = common();

function UserDetail() {

    const member_idx = useSelector((state) => state.user.loginInfo || null);
    
    const { pModal, ModalComponent} = useModal();
    const { useAlert, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    const [data, setData] = useState([]);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const targetIdx = queryParams.get('id');


    const fetchData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_member/out/get_detail`, {member_idx : parseInt(targetIdx)} , {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const data = response.data.data;
                setData(data)
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
        } finally {
            pLoadingOff();
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    const defaultImageUrl = '/img/userImg.png';

    return (
        <>
            <ModalComponent />
            <div className="components_wrap">
                <span className='components_wrap_title'>회원 검색</span>
                <div className="p_user_detail_wrap">

                    {(!member_idx || (typeof member_idx === 'object' && Object.keys(member_idx).length === 0)) ? (
                        <>
                        {/* 로그아웃 상태 */}
                        <div className="user_profile">
                            <div className="left_con">
                                <div className="imgCon">
                                    <div className="imgBg"></div>
                                    <div 
                                        className="profile_image" 
                                        style={{ 
                                        backgroundImage: `url(${defaultImageUrl})` 
                                        }}
                                    ></div>
                                </div>
                            </div>
                            <div className="right_con">
                                <div className="profile_info">
                                    <div className="user_detail_name_box">
                                        <i className='name_badge' style={{ backgroundImage: `url(${data.badge})` }}></i>
                                        <h2>{data.name || ''}</h2>
                                    </div>
                                    <div className="profile_details">
                                        <div className='profile_details_half_box'>
                                            <div className="profile_details_box">
                                                <span className='profile_details_tit'>직장</span>
                                                <span>{data.job || ''}</span>
                                            </div>
                                            <div className="profile_details_box">
                                                <span className='profile_details_tit'>입회시기</span>
                                                <span>{data.joinDate || ''}</span>
                                            </div>
                                        </div>
                                        <div className='profile_details_half_box'>
                                            <div className="profile_details_box">
                                                <span className='profile_details_tit'>이메일</span>
                                                <span>{data.email || ''}</span>
                                            </div>
                                            <div className="profile_details_box">
                                                <span className='profile_details_tit'>생년월일</span>
                                                <span>{data.birthDate || ''}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="user_additional_info">
                                    <div className="info_section">
                                        <h3>경력</h3>
                                        <ul className='user_info_detail'>
                                            {(data.career || []).map((event, index) => (
                                                <li key={index}>{event.career}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="info_section">
                                        <h3>YEHS 경력</h3>
                                        <ul className='user_info_detail'>
                                            {(data.organization || []).map((event, index) => (
                                                <li key={index}>{event.yearName}년도 {event.deptName} {event.position}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </>
                    ):(
                        <>
                        {/* 로그인 상태 */}
                        <div className="user_profile">
                            <div className="left_con">
                                <div className="imgCon">
                                    <div className="imgBg"></div>
                                    <div 
                                        className="profile_image" 
                                        style={{ 
                                        backgroundImage: `url(${data.thumbnail || defaultImageUrl})` 
                                        }}
                                    ></div>
                                </div>
                            </div>
                            <div className="right_con">
                                <div className="profile_info">
                                    <div className="user_detail_name_box">
                                        <i className='name_badge' style={{ backgroundImage: `url(/img/${data.gradeImg})` }}></i>
                                        <h2>{data.name || ''}</h2>
                                    </div>
                                    <div className="profile_details">
                                        <div className='profile_details_half_box'>
                                            <div className="profile_details_box">
                                                <span className='profile_details_tit'>직장</span>
                                                <span>{data.job || '-'}</span>
                                            </div>
                                            <div className="profile_details_box">
                                                <span className='profile_details_tit'>입회시기</span>
                                                <span>{data.year || ''}-{data.month || ''}</span>
                                            </div>
                                        </div>
                                        <div className='profile_details_half_box'>
                                            <div className="profile_details_box">
                                                <span className='profile_details_tit'>이메일</span>
                                                <span>{data.email || '-'}</span>
                                            </div>
                                            <div className="profile_details_box">
                                                <span className='profile_details_tit'>생년월일</span>
                                                <span>{data.birth || '-'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="user_additional_info">
                                    <div className="info_section">
                                        <h3>회원번호</h3>
                                        <ul className='user_info_detail'>
                                            <li>{data.code || ''}</li>
                                        </ul>
                                    </div>
                                    <div className="info_section">
                                        <h3>연락처</h3>
                                        <ul className='user_info_detail'>
                                            <li>{data.phone || '-'}</li>
                                        </ul>
                                    </div>
                                    <div className="info_section">
                                        <h3>키워드</h3>
                                        <ul className='user_info_detail'>
                                            <li>{data.keyword || ''}</li>
                                        </ul>
                                    </div>
                                    <div className="info_section">
                                        <h3>학력</h3>
                                        <ul className='user_info_detail'>
                                        {(data.university || []).map((event, index) => {
                                            // degree 변환
                                            const degreeText = event.degree === 1 ? '학사' : event.degree === 2 ? '석사' : event.degree === 3 ? '박사' : '';
                                            // degreeAttend 변환
                                            const degreeAttendText = event.degreeAttend === 1 ? '재학' : event.degreeAttend === 2 ? '수료' : event.degreeAttend === 3 ? '졸업' : '';
                                            return (
                                                <li key={index}>
                                                    {degreeText ? `[${degreeText}] ` : ''}{event.university} | {event.major} {degreeAttendText}
                                                </li>
                                            );
                                        })}
                                        </ul>
                                    </div>
                                    <div className="info_section">
                                        <h3>경력</h3>
                                        <ul className='user_info_detail'>
                                            {(data.career || []).map((event, index) => (
                                                <li key={index}>{event.career}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="info_section">
                                        <h3>YEHS 경력</h3>
                                        <ul className='user_info_detail'>
                                            {(data.organization || []).map((event, index) => (
                                                <li key={index}>{event.yearName}년도 {event.deptName} {event.position}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="info_section">
                                        <h3>참여행사</h3>
                                        <ul className='user_info_detail'>
                                            {(data.eventHistory || []).map((event, index) => (
                                                <li key={index}>[{event.categoryName || '기타'}] <b>{event.title || '정보없음'}</b> [참여일 : {event.startDate}]</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </>
                    )}
                        
                        
                        



                        
                    
                </div>
            </div>

        </>
    );
}

export default UserDetail;
